import React from "react";
import { useNavigate } from "react-router-dom";
import { Navbar, useAuth } from "../components/Shared";
import { Button } from "../components/ui/button";

export default function PilotNotJoined() {
  const { setUser, setToken } = useAuth();
  const navigate = useNavigate();

  function handleSignOut() {
    try {
      localStorage.removeItem("prepmate_token");
      localStorage.removeItem("prepmate_user");
    } catch {}
    setToken("");
    setUser(null);
    navigate("/");
  }

  return (
    <div>
      <Navbar />
      <div className="mx-auto max-w-md px-4 py-20 text-center">
        <h1 className="text-2xl font-bold mb-3">Invite-only pilot</h1>
        <p className="text-neutral-600 text-sm leading-relaxed mb-8">
          This is a private pilot. Please use your invite link to join, or contact us at{" "}
          <a href="mailto:david@prepmate.app" className="underline hover:text-black">david@prepmate.app</a>{" "}
          if you need access.
        </p>
        <Button onClick={handleSignOut} className="bg-black text-white hover:bg-neutral-800">
          Sign out
        </Button>
      </div>
    </div>
  );
}
